// @ts-nocheck
import React from 'react';

import { useTranslation } from '@crehana/i18n';
import Text from 'crehana-ui/Text';
import Container from 'Shared/ui/Container';
import { grayDark } from 'crehana-ui/styles/colors';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';

import HeartBreak from 'crehana-icons/HeartBreak';

import { SHOPPING_CART_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';

const EmptyCartContent = () => {
  const { t } = useTranslation(SHOPPING_CART_TRANSLATION_KEY);

  return (
    <Container>
      <div className="p-24 bg-gray-lighter sm:p-32 sm:flex sm:items-center">
        <HeartBreak
          className="mb-16 sm:mb-0 sm:mr-24"
          size={40}
          color={grayDark}
        />
        <div className="w-full">
          <Text
            type="subtitle3"
            responsive="sm"
            as="p"
            className="mb-8"
            data-cy="emptyTitlePc"
          >
            {t('YOUR_CART_IS_EMPTY')}
          </Text>
          <div className="flex items-center justify-between w-full flex-col sm:flex-row">
            <div>
              <Text type="body3" as="p" responsive="sm">
                {t('EXPLORE_THE_CATALOG_AND_START_ADDING_COURES')}
              </Text>
            </div>
            <PrimaryButton
              className="mt-16 sm:mt-0"
              label={t('GO_TO_CATALOG')}
              onClick={() => {
                if (window !== undefined) {
                  window.location.href = '/cursos-online/';
                }
              }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default EmptyCartContent;
